const ElementType = {
    SERVICE: 'service',
    ELEMENT: 'element',
    ATTRIBUTE: 'attribute'
};

module.exports = ElementType;